import { InsuranceTableType } from './InsuranceTableType';

export const InsuranceTableTypeOptions = {
    BeforeClosingMissing: {
        id: InsuranceTableType.BeforeClosingMissing,
        name: 'Missing Items',
        isExpanded: true,
        canRepay: false,
        canUpdate: true,
        canRecycle: false,
        canDelete: true,
    },
    BeforeClosingGood: {
        id: InsuranceTableType.BeforeClosingGood,
        name: 'Good',
        isExpanded: false,
        canRepay: false,
        canUpdate: true,
        canRecycle: false,
        canDelete: true,
    },
    ClosedMissing: {
        id: InsuranceTableType.ClosedMissing,
        name: 'Missing Items',
        isExpanded: true,
        canRepay: true,
        canUpdate: true,
        canRecycle: false,
        canDelete: true,
    },
    ClosedGood: {
        id: InsuranceTableType.ClosedGood,
        name: 'Good',
        isExpanded: false,
        canRepay: true,
        canUpdate: true,
        canRecycle: false,
        canDelete: true,
    },
    Repaid: {
        id: InsuranceTableType.Repaid,
        name: 'Repaid',
        isExpanded: false,
        canRepay: false,
        canUpdate: false,
        canRecycle: false,
        canDelete: false,
    },
    Recycle: {
        id: InsuranceTableType.Recycle,
        name: 'Recycle Bin',
        isExpanded: false,
        canRepay: false,
        canUpdate: false,
        canRecycle: true,
        canDelete: false,
    },
};
